// One sale's People, Access or Sales tab (docs/SALES-ACCESS.md); People keeps its filters in the query.
// Any other word after the id is not a tab: it opens Overview.
import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SALE_TAB_IDS, SalesAccessSaleRoute } from '../modules/venue-port/tkt/SalesAccessRoutes';

export const Route = createFileRoute('/sales-access/$id/$tab')({
  component: function SalesAccessTab() {
    const { id, tab } = Route.useParams();
    return <SalesAccessSaleRoute salesAccessId={id} tab={SALE_TAB_IDS.includes(tab) ? tab : 'overview'} />;
  },
});
